export default "__VITE_ASSET__Dtgy3yuN__"